module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/home/benefits/gen-gold/gen-gold.component.scss
// module id = ./src/app/home/benefits/gen-gold/gen-gold.component.scss
// module chunks = main